import { render, staticRenderFns } from "./TerminosCondiciones.vue?vue&type=template&id=274ece1b&scoped=true&"
import script from "./TerminosCondiciones.vue?vue&type=script&lang=js&"
export * from "./TerminosCondiciones.vue?vue&type=script&lang=js&"
import style0 from "./TerminosCondiciones.vue?vue&type=style&index=0&id=274ece1b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ece1b",
  null
  
)

export default component.exports